import styled from 'styled-components';

export const Content = styled.div`
  .switcher {
    display: flex;
  }

  .customTable {
    width: 100%;
    height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 5px 0 20px;

    td p {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      padding: 10px 0;
    }
  }

  .cancelBtn {
    width: 130px;
  }
`;
